import { useEffect, useContext, useState } from "react";
import { post } from "../../../adapters/xhr/api";
import stylesCommonData from "./index.module.css";

import UnifiedTaxDeclarationContext from "../../../contexts/UnifiedTaxDeclarationProvider";
import ResidentialUnitsList from "./TypeLists/residentialUnitsList";
import CommercialUnitsList from "./TypeLists/commercialUnitsList";
import IndustrialFacilityUnitsList from "./TypeLists/industrialFacilityUnitsList";
import ProductionFacilityUnitsList from "./TypeLists/productionFacilityUnitsList";
import PetroleumFacilityUnitsList from "./TypeLists/petroleumFacilityUnitsList";
import MineQuarryFacilityUnitsList from "./TypeLists/mineQuarryFacilityUnitsList";
import AdministrativeUnitsList from "./TypeLists/administrativeUnitList";
import ServiceUnitList from "./TypeLists/serviceUnitList";
import FixedInstallationUnitsList from "./TypeLists/fixedIntallationUnitList";
import ServiceFacilityList from "./TypeLists/serviceFacilityList";
import VacantLandsList from "./TypeLists/vacantLandsList";
import HotelFacilitiesList from "./TypeLists/hotelFacilitiesList";

const baseTabs = [
  {
    id: "residential",
    dataKey: "residential_units",
    label: "الوحدات السكنية",
    component: ResidentialUnitsList,
  },
  {
    id: "commercial_administrative_service",
    dataKey: ["commercial_units", "administrative_units", "service_units"],
    label: "الوحدات التجارية، و الإدارية، و الخدمية",
    component: ServiceUnitList,
  },
  {
    id: "service_facilities",
    dataKey: "service_facilities",
    label: "منشآت خدمية",
    component: ServiceFacilityList,
  },
  {
    id: "industrial_facility",
    dataKey: "industrial_facility",
    label: "المنشآت الصناعية",
    component: IndustrialFacilityUnitsList,
  },
  {
    id: "production_facility",
    dataKey: "production_facility",
    label: "المنشآت الإنتاجية",
    component: ProductionFacilityUnitsList,
  },
  {
    id: "mine_quarry",
    dataKey: "mine_quarry",
    label: "مناجم محاجر ملاحات",
    component: MineQuarryFacilityUnitsList,
  },
  {
    id: "petroleum_facility",
    dataKey: "petroleum_facility",
    label: "المنشآت البترولية",
    component: PetroleumFacilityUnitsList,
  },
  {
    id: "fixed_installation",
    dataKey: "fixed_installation",
    label: "التركيبات الثابتة",
    component: FixedInstallationUnitsList,
  },
  {
    id: "vacant_land",
    dataKey: "vacant_land",
    label: "أراضي فضاء مستغلة",
    component: VacantLandsList,
  },
  {
    id: "hotel_facility",
    dataKey: "hotel_facility",
    label: "المنشآت الفندقية",
    component: HotelFacilitiesList,
  },
];

const CommonTabs = ({ onDeleteSuccess }) => {
  const unifiedTaxDeclarationContext = useContext(UnifiedTaxDeclarationContext);
  const {
    declarationRequest,
    updateDeclarationUnit,
    updateDeclarationRequest,
  } = unifiedTaxDeclarationContext;

  // Filter tabs to show only items with data
  const filteredTabs = baseTabs.filter((tab) => {
    // Handle multiple dataKeys (array)
    if (Array.isArray(tab.dataKey)) {
      return tab.dataKey.some((key) => {
        const dataProperty = declarationRequest?.[key];
        return (
          dataProperty?.data &&
          Array.isArray(dataProperty.data) &&
          dataProperty.data.length > 0
        );
      });
    }
    // Handle single dataKey (string)
    const dataProperty = declarationRequest?.[tab.dataKey];
    return (
      dataProperty?.data &&
      Array.isArray(dataProperty.data) &&
      dataProperty.data.length > 0
    );
  });

  const [activeTab, setActiveTab] = useState(null);

  // Set active tab to first tab when filtered tabs change
  useEffect(() => {
    if (filteredTabs.length > 0 && !activeTab) {
      setActiveTab(filteredTabs[0].id);
    }
  }, [filteredTabs, activeTab]);

  //TODo check if working after update
  useEffect(() => {
    updateDeclarationRequest("activeTab", activeTab);
  }, [activeTab]);

  const ActiveTabComponent = filteredTabs.find(
    (tab) => tab.id === activeTab,
  )?.component;

  return (
    <>
      <div dir="rtl" className={`${stylesCommonData["units-tabs"]}`}>
        <ul className={`${stylesCommonData["tabs-header"]}`}>
          {filteredTabs?.map((tab) => (
            <li
              key={tab.id}
              className={`${activeTab === tab.id ? stylesCommonData["active"] : ""}`}
              onClick={() => setActiveTab(tab.id)}
            >
              {tab.label}
            </li>
          ))}
        </ul>

        <div className={`${stylesCommonData["tabs-body"]}`}>
          {ActiveTabComponent && (
            <ActiveTabComponent onDeleteSuccess={onDeleteSuccess} />
          )}
        </div>
      </div>
    </>
  );
};
export default CommonTabs;
